import React from 'react';

const GovernmentBackedSchemes = () => {
  return (
    <div style={{ padding: '50px', fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", lineHeight: '1.8' }}>
      <h1 style={{ fontSize: '36px', marginBottom: '20px', color: '#22225f' }}>Government-Backed Schemes</h1>
      <p>
        Government-backed schemes such as Mudra Loans, CGTMSE, and Stand-Up India provide affordable credit solutions to
        startups, MSMEs, and underserved sectors. These schemes come with favorable terms and minimal collateral
        requirements.
      </p>
      <h2 style={{ fontSize: '28px', color: '#22225f', marginTop: '30px' }}>Popular Schemes</h2>
      <ul style={{ paddingLeft: '20px', listStyleType: 'disc' }}>
        <li><strong>Mudra Loans:</strong> Loans up to ₹10 lakhs for micro and small enterprises.</li>
        <li><strong>CGTMSE:</strong> Collateral-free loans for MSMEs.</li>
        <li><strong>Stand-Up India:</strong> Loans for SC/ST and women entrepreneurs.</li>
      </ul>
    </div>
  );
};

export default GovernmentBackedSchemes;
